export default "__VITE_ASSET__Daq9TUzs__"